module.exports = __webpack_public_path__ + "img/visits-logo.61767da5.svg";